import AppointmentList from "@/app/individual/appointments/appointments.page";
import AppointmentCalendarPage from "@/app/individual/appointments/calendar.page";
import WorkerAppointmentPage from "@/app/individual/appointments/appointment.page";
import Home from "@/app/individual/home";
import SchedulePage from "@/app/individual/schedule/schedule.page";
import DailyWorkPage from "@/app/individual/daily-work/daily-work.page";
import DailyWorkExecutionDetail from "@/app/individual/daily-work/execution-detail";
import IndividualStripeConnectPage from "@/app/individual/stripe-connect/stripe-connect.page";

export const individual_routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/appointments",
    element: <AppointmentList />,
  },
  {
    path: "/appointments/:appointmentId",
    element: <WorkerAppointmentPage />,
  },
  {
    path: "/appointments/calendar",
    element: <AppointmentCalendarPage />,
  },
  {
    path: "/schedule",
    element: <SchedulePage />,
  },
  {
    path: "/daily-work",
    element: <DailyWorkPage />,
  },
  {
    path: "/daily-work/:dayId/execution",
    element: <DailyWorkExecutionDetail />,
  },
  {
    path: "/daily-work/:dayId/execution/:executionId",
    element: <DailyWorkExecutionDetail />,
  },
  {
    path: "/stripe-connect",
    element: <IndividualStripeConnectPage />,
  },
];
